import EditIcon from '@mui/icons-material/Edit';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useContext, useState } from 'react';

import { ConfigManager } from '../../../../../../application/config/ConfigManager';
import { inject } from '../../../../../../common/container/inject';
import { IRouterService, RouterServiceToken } from '../../../../../../service/route/IRouterService';
import { UserSystemRoleModelPermissionMap } from '../../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { IMainLayoutDomainStore } from '../../../store/domain/IMainLayoutDomainStore';
import { ILayoutUser } from '../../../store/ui/ILayoutUser';
import { MainLayoutLeftNavigationTopLogo } from '../parts/MainLayoutLeftNavigationTopLogo';
import { useStyles } from '../useStyles';
import { PasswordEditModal } from './PasswordEditModal';
import { ContainerContext } from '../../../../../../common/container/ContainerContext';

interface NavigationHeaderProps {
  layoutUser: ILayoutUser;
  layoutDomain: IMainLayoutDomainStore;
}

export const NavigationHeader = observer(({ layoutUser, layoutDomain }: NavigationHeaderProps) => {
  const classes = useStyles();
  const context = useContext(ContainerContext);
  const router = inject<IRouterService>(RouterServiceToken);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const isAdmin = layoutDomain.userHaveAnyAccess([UserSystemRoleModelPermissionMap['global-allow-any']]);

  const userSourceType = layoutDomain.ui.userSourceType.value;
  const MainLayoutLeftNavigationTopLogoComponent = context.get(
    MainLayoutLeftNavigationTopLogo,
  ) as typeof MainLayoutLeftNavigationTopLogo;
  const handlePasswordModalClose = () => {
    setIsPasswordModalOpen(false);
  };

  return (
    <>
      <div className={classes.titleContainer}>
        <MainLayoutLeftNavigationTopLogoComponent
          isShow={layoutDomain.config.extensions.getExtensionsConfigByName('EXTENSION_MVIDEO_IS_SHOW_LOGO', true)}
        />

        <br />

        <Stack justifyContent="space-between" direction="row" alignItems="center" sx={{ mb: 2, mr: 1 }}>
          <Typography color="secondary" variant="subtitle2" align="left" className={classes.titleText}>
            {layoutUser.displayName}
          </Typography>

          <Stack direction="row" flex={1} alignItems="center" justifyContent="flex-end">
            {!isAdmin && userSourceType === 'internal' && (
              <IconButton color="primary" onClick={() => setIsPasswordModalOpen(true)}>
                <EditIcon color="secondary" />
              </IconButton>
            )}
            {!ConfigManager.getConfig().extensions.include.includes('asm') && (
              <IconButton
                color="primary"
                onClick={() => {
                  router.goTo('/notification');
                  layoutDomain.isSelected.setValue('notification');
                }}
              >
                <Badge
                  sx={{ '& .MuiBadge-badge': { backgroundColor: '#AE3030', p: 0, height: 16 } }}
                  badgeContent={layoutDomain.notificationDomain.ui.notificationUnreadCount.value}
                >
                  <NotificationsIcon color="secondary" />
                </Badge>
              </IconButton>
            )}
          </Stack>
        </Stack>
      </div>

      <PasswordEditModal
        open={isPasswordModalOpen}
        handleClose={handlePasswordModalClose}
        layoutDomain={layoutDomain}
      />
    </>
  );
});
